import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AcessosBarradosIpComponent } from './acessos-barrados-ip.component';

@NgModule({
  declarations: [AcessosBarradosIpComponent],
  imports: [CommonModule],
  exports: [AcessosBarradosIpComponent]
})
export class AcessosBarradosIpModule { }
